import React from "react";
import LazyloadImage from "./LazyloadImage";

export default class FooterThemeImage extends React.Component {
  static defaultProps = {
    containerClassName: 'footer-theme-image-container',
    desktopWidth: 301,
    desktopHeight: 216,
    mobileWidth: 170,
    mobileHeight: 122
  };

  render() {
    return <LazyloadImage {...this.props} />
  }
}